
define('ldsh!templates/main', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="navbar navbar-default navbar-static-top" role="navigation">\n  <div class="container">\n    <div class="navbar-header">\n      \n      <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">\n        <span class="sr-only">Toggle navigation</span>\n        <span class="icon-bar"></span>\n        <span class="icon-bar"></span>\n        <span class="icon-bar"></span>\n      </button>\n\n      <a class="navbar-brand" href="#">Example App</a>\n    </div>\n\n    <div class="navbar-collapse collapse">\n      <ul class="nav navbar-nav navbar-right navigation">\n      </ul>\n    </div>\n  </div>\n</div>\n\n<div class="container main">\n\n\n\n</div>\n\n<footer class="container">\n  <hr>\n</footer>';

}
return __p
};});

